import React, {Component} from 'react';
import './RmField.css';
import PropTypes from 'prop-types';

export default class RmField extends Component {
    handleChange(e) {
        if (this.props.onChange) {
            this.props.onChange(e.target.value);
        }
    }

    handleClearClick(e) {
        e.preventDefault();

        if (this.props.onChange) {
            this.props.onChange("");
        }

        if (this.refInput) {
            this.refInput.value = "";
            this.refInput.focus();
        }

        if (this.props.onClear) {
            this.props.onClear();
        }

        return false;
    }

    render() {
        let classNames = ["RmField"];

        if (!this.props.iconName) {
            classNames.push("RmField--iconless")
        }

        if (this.props.marginOff) {
            classNames.push("RmField--marginOff");
        }

        if (this.props.className) {
            classNames.push(this.props.className);
        }

        return (
            <div className={classNames.join(' ')}>
                {this.props.iconName &&
                <label className={"RmField__label"} htmlFor={this.props.id} title={this.props.label}>
                    <i className={"mdi mdi-" + this.props.iconName}/>
                </label>
                }

                {!this.props.inputOverride &&
                <input className={"RmField__input"} type={this.props.inputType || "text"}
                       placeholder={this.props.label} name={this.props.id} value={this.props.value || ""}
                       onChange={this.handleChange.bind(this)} id={this.props.nonUnique ? null : this.props.id}
                       ref={(input) => {
                           this.refInput = input;
                       }} disabled={!!this.props.disabled}
                />}

                {this.props.inputOverride || null}

                {!this.props.disableClear &&
                <a href={"#" + this.props.id} title={"Veld legen"} tabIndex="-1" className="RmField__clear"
                   onClick={this.handleClearClick.bind(this)}>
                    <i className="mdi mdi-close"/>
                </a>
                }
            </div>
        );
    }
}

RmField.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    inputType: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
    disabled: PropTypes.bool,
    disableClear: PropTypes.bool,
    marginOff: PropTypes.bool,
    nonUnique: PropTypes.bool,
    inputOverride: PropTypes.any,
    className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/Forms/RmField.js